import { useTranslation } from 'react-i18next';
import { Copy, Check, Undo2, Loader2 } from 'lucide-react';
import { Button } from '@/components/v2/ui';

export interface AIFieldPreviewActionsProps {
  applied: boolean;
  applying: boolean;
  copied: boolean;
  onCopy: () => void;
  onApply: () => void;
  onUndo: () => void;
  onClose: () => void;
}

/** Footer actions for the preview popover (apply / undo / copy / discard). */
export function AIFieldPreviewActions({
  applied,
  applying,
  copied,
  onCopy,
  onApply,
  onUndo,
  onClose,
}: AIFieldPreviewActionsProps) {
  const { t } = useTranslation();

  if (applied) {
    return (
      <div className="mt-4 flex items-center justify-between">
        <span className="text-sm text-emerald-600 dark:text-emerald-400 flex items-center gap-1">
          <Check className="h-4 w-4" />
          {t('aiField.applied')}
        </span>
        <div className="flex gap-2">
          <Button variant="outline" onClick={onUndo} disabled={applying}>
            <Undo2 className="h-4 w-4 mr-2" />
            {t('aiField.undo')}
          </Button>
          <Button onClick={onClose}>{t('common.close')}</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-4 flex justify-end gap-2">
      <Button variant="ghost" size="sm" onClick={onCopy}>
        {copied ? <Check className="h-4 w-4 mr-2" /> : <Copy className="h-4 w-4 mr-2" />}
        {copied ? t('aiField.copied') : t('aiField.copy')}
      </Button>
      <Button variant="secondary" onClick={onClose} disabled={applying}>
        {t('aiField.discard')}
      </Button>
      <Button onClick={onApply} disabled={applying}>
        {applying && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
        {t('aiField.apply')}
      </Button>
    </div>
  );
}
